import { createFileRoute, redirect } from '@tanstack/react-router'
import { BridgePlayground } from './-components/bridge-playground'

export const Route = createFileRoute('/dev/bridge')({
  beforeLoad: () => {
    if (!import.meta.env.DEV) throw redirect({ to: '/' })
  },
  component: BridgePlayground,
})
